<ng-container *ngIf="!isLoading else loading">
	<div class="card-title">
		<span translate>order-tracking.card.batches-in-stock</span>
	</div>
	<div class="available-batches-block">
		<div class="available-batches-grid">
			<ng-container *ngFor="let batch of batches; let i = index">
				<span class="available-batches-col-accent" translate [translateParams]="{ value: batch.daysInStock }">order-tracking.card.callables-batches.days</span>
				<a class="pill pill-info pill-clickable"
						[routerLink]="['/order-tracking/order/card', batch.supplierOrderNumber, batch.supplierOrderItemNumber]">
					{{ getOrderName(batch) }}
				</a>
				<a class="available-batches-link mobile-hide" [routerLink]="['/order-tracking/batch/card', batch.id]">{{ batch.batchReference }}</a>
				<span class="mobile-hide">{{batch.steelgradeDescription}}</span>
				<span class="mobile-hide">{{ batch | copoDimension }}</span>
				<span class="mobile-hide">{{ batch.customerArticleReference }}</span>
			</ng-container>
		</div>
	</div>
	<div class="card-block-footer mobile-hide">
		<button type="button" mat-button color="primary" (click)="viewDetails()">
			<span translate>order-tracking.card.callables-batches.view-details</span>
			<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
